module.exports = __webpack_public_path__ + "img/marker-processing.6819063a.svg";